import { styled } from '@mui/material';
import { Box, ListItemButton } from '@mui/material';

const HeaderContainer = styled(Box, {
  name: 'header-container',
  slot: 'Root',
})({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '0px 16px',
  alignItems: 'center',
  marginBottom: '16px',
});

const ListContentContainer = styled(Box, {
  name: 'list-content-container',
  slot: 'Root',
})(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
}));

const DeliverableListItem = styled(ListItemButton, {
  name: 'deliverable-list-item',
  slot: 'Root',
})(({ theme }) => ({
  padding: '16px',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const ViewPanelContainer = styled(Box, {
  name: 'view-panel-container',
  slot: 'Root',
})(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.divider}`,
}));

const ViewHeaderContainer = styled(Box, {
  name: 'view-header-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 0',
}));

const AcceptRejectButtonsContainer = styled(Box, {
  name: 'accept-reject-buttons-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '8px',
}));

const GroupActionButtonsContainer = styled(Box, {
  name: 'group-button-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
}));

const DeliverableDetailsContainer = styled(Box, {
  name: 'deliverable-details-container',
  slot: 'Root',
})(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '8px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const DocumentsListContainer = styled(Box, {
  name: 'documents-list-container',
  slot: 'Root',
})(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 16px',
}));

export {
  HeaderContainer,
  ListContentContainer,
  DeliverableListItem,
  ViewPanelContainer,
  ViewHeaderContainer,
  DocumentsListContainer,
  DeliverableDetailsContainer,
  GroupActionButtonsContainer,
  AcceptRejectButtonsContainer,
};
